import request from './common/request'
import qs from 'qs'

import {MERCHANT_EVALUATION_JUDGE_BATCH_ADD, MERCHANT_EVALUATION_JUDGE_URI} from './urls'
import axios from 'axios'
import store from '@/store'

// 列表
async function list (params) {
  return request(
    {
      url: MERCHANT_EVALUATION_JUDGE_URI,
      method: 'GET',
      params
    }
  )
}

// 详情
async function getById (id) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_JUDGE_URI}/${id}`,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: MERCHANT_EVALUATION_JUDGE_URI,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 导入评委
async function uploadJudge (forms) {
  const result = await axios.post(`${process.env.BASE_API}${MERCHANT_EVALUATION_JUDGE_URI}/upload`, forms,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${store.state.MerchantAuth.accessToken}`
      }
    }
  )
  return result
}

// 批量添加
async function batchAdd (data) {
  return request(
    {
      url: MERCHANT_EVALUATION_JUDGE_BATCH_ADD,
      method: 'POST',
      data: data
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_JUDGE_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

// 删除
async function remove (id) {
  return request(
    {
      url: `${MERCHANT_EVALUATION_JUDGE_URI}/${id}`,
      method: 'DELETE'
    }
  )
}

export default {
  list,
  getById,
  insert,
  batchAdd,
  update,
  uploadJudge,
  remove
}



// WEBPACK FOOTER //
// ./src/api/merchant-evaluation-judge.js